import { useEffect, useState } from "react";
import OnboardingPopup from "../../components/onboardingPopups";
import "./style.scss";
import moment from "moment";
import { DndProvider } from "react-dnd";
// import MultiBackend from "react-dnd-multi-backend";
// import HTML5toTouch from "react-dnd-multi-backend/dist/esm/HTML5toTouch";
import DisplayItem from "../../components/displayItem";
import BurgerOnTray from "../../components/burgerOnTray";

// images ---
import burgerImage from "../../assets/images/onboarding/burger.svg";
import closeButtonImage from "../../assets/images/close.svg";
import table3Image from "../../assets/images/desktop/table3.png";
import table2Image from "../../assets/images/desktop/table2.png";
import table1Image from "../../assets/images/desktop/table1.svg";
import trashImage from "../../assets/images/desktop/trash.svg";

// Ingredient tray images
import pattyUncookedImage from "../../assets/images/tray/t1.svg";
import cheeseUncookedImage from "../../assets/images//tray/t2.svg";
import lettuceImage from "../../assets/images//tray/t3.svg";
import bunsImage from "../../assets/images//tray/t4.svg";
import trashMobileImage from "../../assets/images//tray/t5.svg";

//patty
import pattyUncookedGrillTrayImage from "../../assets/images/test1.svg";
import pattyOvercookedGrillTrayImage from "../../assets/images/test3.svg";
import TimerCircle from "../../components/timerCircle";
import ButtonPrimary from "../../components/buttonPrimary";

// for next screen
import { useDispatch } from "react-redux";
import { setTimer, setStartTime, resetAll } from "../../store/ingredient";

// music
import buttonSound from "../../assets/sound/button.mp3";
import { TouchBackend } from "react-dnd-touch-backend";
import { useMediaQuery } from "usehooks-ts";
import { HTML5Backend } from "react-dnd-html5-backend";

export default function Onboarding(props) {
  const [step, setStep] = useState(0);
  const [patty, setPatty] = useState(pattyUncookedGrillTrayImage);

  const handleScreenTap = () => {
    setStep(step + 1);
  };

  const handlePrevTap = () => {
    if (step == 0) return;
    setStep(step - 1);
  };

  useEffect(() => {
    switch (step) {
      case 5: {
        setPatty(pattyOvercookedGrillTrayImage);
      }
    }
  });

  const dispatch = useDispatch();
  const buttonClickHandler = () => {
    props.history.push("/main");
    // var now = moment(); // new Date().getTime();
    dispatch(setTimer(Date.now() + 300000));
    dispatch(setStartTime(moment()));
    dispatch(resetAll());

    const buttonSound = document.getElementById("buttonSound");
    buttonSound.play();
  };
  const isMobile = useMediaQuery("(min-width: 968px)");
  return (
    <DndProvider backend={isMobile ? HTML5Backend : TouchBackend}>
      {step > 0 && (
        <button className="btn prev-btn" onClick={handlePrevTap}>
          &lt; Previous
        </button>
      )}

      <div className="onboarding-root" onClick={() => handleScreenTap()}>
        {/* <OnboardingPopup
                title={'Time to make some Burgers!'}
                description={'You’re the chef of a busy cafe and you’ll be serving burger orders before the time runs out.'}
                width={'90%'}
            /> */}

        <div className="bg-trays bg-primary">
          <div className="header-onboarding">
            <div className="empty">{/* empty */}</div>
            <div>4:30</div>
            <div>
              <img src={closeButtonImage} alt="" />
            </div>
          </div>
          <div className="header-onboarding points-container">
            <div className="half"></div>
            <div className="half"></div>
          </div>

          <div className="display-items-container">
            <div className="content-container">
              <div className="inner-section">
                <div className="row justify-content-center">
                  <div
                    className={`col-3 ${
                      [1, 2, 6, 8].includes(step) ? "highlight" : ""
                    }`}
                  >
                    <DisplayItem
                      // index={0}
                      burger={"b1"}
                      pushedTime={moment.now()}
                      // expectedEndTime={}
                    />
                  </div>

                  <div className="col-3">
                    <DisplayItem
                      // index={0}
                      burger={"b2"}
                      pushedTime={moment.now()}
                      // expectedEndTime={}
                    />
                  </div>

                  <div className="col-3">
                    <DisplayItem
                      // index={0}
                      burger={"b3"}
                      pushedTime={moment.now()}
                      // expectedEndTime={}
                    />
                  </div>

                  <div className="col-3">
                    <DisplayItem
                      // index={0}
                      burger={"b4"}
                      pushedTime={moment.now()}
                      // expectedEndTime={}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tables">
            <div
              className="table table3"
              style={{ backgroundImage: `url('${table3Image}')` }}
            >
              <div className="row trayRow justify-content-center">
                <div
                  className={`col-4 burgerOnTray-item px-0 ${
                    [7, 8].includes(step) ? "highlight" : ""
                  }`}
                >
                  <BurgerOnTray
                    ingredients={[
                      "buntop",
                      "lettuce",
                      "cheese",
                      "pattyCooked",
                      "bunbottom",
                    ].reverse()}
                  />
                </div>
              </div>
            </div>
            <div
              className="table table2"
              style={{ backgroundImage: `url('${table2Image}')` }}
            >
              <div className="row trayRow justify-content-center">
                <div
                  className={`col-4 grill-ingredient ${
                    [3, 4, 5].includes(step) ? "highlight" : ""
                  }`}
                >
                  <img src={patty} alt="" />
                  <TimerCircle time={12} start />
                </div>
              </div>
            </div>
            <div className="table table1 multi-table">
              <div
                className="table table1"
                style={{ backgroundImage: `url('${table1Image}')` }}
              >
                <div className="row trayRow pt-8x">
                  <div className="col-2 col-md-3 ingredient">
                    <img src={bunsImage} alt="" />
                  </div>
                  <div
                    className={`col-2 col-md-3 ingredient ${
                      [2].includes(step) ? "highlight" : ""
                    }`}
                  >
                    <img
                      src={pattyUncookedImage}
                      className={[2].includes(step) ? "highlight" : null}
                      alt=""
                    />
                  </div>
                  <div
                    className={`col-2 col-md-3 ingredient ${
                      [6, 7].includes(step) ? "highlight" : ""
                    }`}
                  >
                    <img src={cheeseUncookedImage} alt="" />
                  </div>
                  <div className="col-2 col-md-3 ingredient">
                    <img src={lettuceImage} alt="" />
                  </div>
                  <div className="col-2 col-md-3 ingredient trash">
                    <img src={trashMobileImage} alt="" />
                  </div>
                </div>
              </div>
              <div
                className="trash only-desktop"
                style={{ backgroundImage: `url('${trashImage}')` }}
              ></div>
            </div>
          </div>
        </div>

        <div className="full-overlay">
          {step == 0 && (
            <OnboardingPopup
              title={"Time to make some Burgers!"}
              description={
                "You’re the chef of a busy cafe and you’ll be serving burger orders before the time runs out."
              }
              className="first-popup"
              descriptionColor={"#737379"}
              topLeftOutImage={burgerImage}
            />
          )}

          {step == 1 && (
            <OnboardingPopup
              description={
                "Orders appear here, you need to serve these before the order time runs out."
              }
            />
          )}

          {step == 2 && (
            <>
              <OnboardingPopup
                description={
                  "This order asks for a burger patty and a slice of cheese."
                }
                className="step2-1"
              />

              <OnboardingPopup
                description={"Drag the burger patty to the grilling station."}
                className="step2-2"
              />
            </>
          )}

          {step == 3 && (
            <OnboardingPopup
              description={
                "For a perfectly cooked patty, wait for it to hit the green zone on the meter and then drag it on a bun."
              }
            />
          )}

          {step == 4 && (
            <OnboardingPopup
              description={"Drag it to one of the buns to place the patty"}
            />
          )}

          {step == 5 && (
            <OnboardingPopup
              description={
                "If you overcook the patty, you will not be able to serve it. Discard it by Dragging it to trash."
              }
            />
          )}

          {step == 6 && (
            <>
              <OnboardingPopup
                description={
                  "Great! Complete this order by placing the other ingredients."
                }
                className="step6-1"
              />

              <OnboardingPopup
                description={"Drag the cheese slice to the burger."}
                className="step6-2"
              />
            </>
          )}

          {step == 7 && (
            <OnboardingPopup description={"Your order looks ready to serve!"} />
          )}

          {step == 8 && (
            <OnboardingPopup
              description={"Drag the burger to complete your order."}
            />
          )}

          {step > 8 && (
            <div className="start-game-btn">
              <ButtonPrimary
                buttonText="Start"
                onClickHandler={() => buttonClickHandler()}
              />
            </div>
          )}

          {step <= 8 && (
            <div className="bottom-text">Tap anywhere to proceed.</div>
          )}
        </div>
      </div>

      <audio controls id="buttonSound" className="audio-hide">
        <source src={buttonSound} type="audio/mp3" />
      </audio>
    </DndProvider>
  );
}

const burgerQueue = [];
